import { render } from "./ContainingCostOfCare.vue?vue&type=template&id=35f8a206&scoped=true"
import script from "./ContainingCostOfCare.vue?vue&type=script&lang=js"
export * from "./ContainingCostOfCare.vue?vue&type=script&lang=js"

import "./ContainingCostOfCare.vue?vue&type=style&index=0&id=35f8a206&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f8a206"]])

export default __exports__